module.exports = __webpack_public_path__ + "static/media/ski-lift.505c7397.svg";